import React, { useRef, useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { axiosEH } from './common/functions'
import { dotWordMidChars } from './common/functions'
import { showResultArr } from './common/functions'
import { getCurrentLevel } from './common/functions'
import { setCurrentLevel } from './common/functions'
import { deleteKeysStartingWith } from './common/functions'

import './spellingbee.css';
import linkAvatars from './linkAvatars-dev.txt';
import jwtUser from '../jwtUser';

export default function FlashcardMaster() {
  const taskDoneMsg = "done. Auto back to Task"
  const user = jwtUser(); // get user token
  const location = useLocation().state.taskId;
  const msgColor = 'black',avaNullURL = "";
  const bgColors = ['#F8F8FF', '#fffafa', '#add8e6', '#0892d0', '#355e3b', ' #9acd32', '#282C35', '#0f0f0f', '#ffe5b4', '#ffb347', '#c9a0dc', '#8a2be2', ' #b38b6d', '#cd7f32', '#f5f5f5', '#848482']
  let bgColorIndex = 0, wordArr = [];
  let userLevel = getCurrentLevel(user.username);
  const firstLanguage = sessionStorage.getItem("firstLanguage");

  const dataArr = useRef([]);
  const wordIndex = useRef(1);
  const score = useRef(0)
  const resultArr = useRef([['word no', 'test word', 'spelled word', 'status', 'score']]);

  const [statusMsg, setStatusMsg] = useState('');
  const [cardSide, setCardSide] = useState('0');  // '0' & '1'
  const [avaURLArr, setAvaURLArr] = useState([]);
  const [textInfoArr, setTextInfoArr] = useState([])
  //(['name', '{"word":"cat",\n"sentence":"Cats and dogs are the top two most popular pets.",\n"syn":"domestic cats, wild cats, big cats",\n"hyper":"domestic animal"}', '{"word":"cat",\n"sentence":"Cats and dogs are the top two most popular pets.",\n"syn":"domestic cats, wild cats, big cats",\n"hyper":"domestic animal"}']);

  const changeBackground = () => {
    if (bgColorIndex >= bgColors.length) bgColorIndex = 0;
    document.body.style.backgroundColor = bgColors[bgColorIndex];
    //console.log("bgColorIndex: ", bgColorIndex);
    ++bgColorIndex;
  }

  function getCardWordArr(arr) {
    let wArr = [], infoArr =[], str, strArr;
    let wordStr = '';
    //return ['cat','dog']

    wArr.push(arr[0]); infoArr.push(arr[0]); 
    for (let i = 1; i < arr.length; i++) {
      arr[i] = JSON.parse(arr[i]); 

      //console.log("textInfoArr: ", i, JSON.stringify(arr[i]))
      // sequence the Obj

      // which lang
      if (arr[i].hasOwnProperty("_wordCN") && firstLanguage == 'simplified-Chinese') {
        wordStr = arr[i]._wordCN;
      } else if (arr[i].hasOwnProperty("_wordTW") && firstLanguage == 'traditional-Chinese') {
        wordStr = arr[i]._wordTW;
      } else {  // English
        wordStr = arr[i].word;
      }
      arr[i] = deleteKeysStartingWith(arr[i], '_word');
      str = JSON.stringify(arr[i])
      arr[i] = JSON.parse(str); 

      wArr.push(arr[i].word);
      str = JSON.stringify(arr[i])
      str = str.replace(/","/g,'",\n"')
      str = str.replace("{","");
      str = str.replace("}",""); 
      //str = str.replace(/{/g,""); str = str.replace(/}/g,"");
      str = str.replace(/"/g,"");

      // dot word mid chars
      strArr = str.split(",")
      strArr[0] = dotWordMidChars(wordStr, userLevel);
      str = strArr.join(","); 
      str = str.replaceAll(':', ': ')
      //console.log("getCardWordArr str: ", str )
      infoArr.push(str)
    }
    str = str.replaceAll(':', ': ')

    const index = str.indexOf("wordCN");
    str = str.slice(0, index)
    infoArr.push(str);
    setTextInfoArr(infoArr)

    return wArr;
  }

  async function getAvaURLArr2(wArr) {
    //wArr = ["demot-219-ES 2022-random-1741188368653-SB-demot","television","soup","house","shop","eightieth","student","sea","run","light","out","animal"  ];
    let temp, temp2, index, wordsArr = []; // reset to zero

    // 1. get the ava name arr
    const res = await axios.get(linkAvatars);
    const avaNameArr = res.data.trim('\n').split('\n');
    //console.log('avaNameArr:', avaNameArr);

    // 2. get ava URLs
    for (let iw = 0; iw < wArr.length; iw++) {
      let thisWordArr =[];

      // 3. ava entry loop
      for (let ia = 0; ia < avaNameArr.length; ia++) {
        // 31) blank
        if (avaNameArr[ia].length ==0) continue;

        // 32) 
        temp = avaNameArr[ia].split(",")
        if (temp.includes(wArr[iw])) {
          thisWordArr.push(temp[0])
        }
      }

      // 4. ava 3 cases
      if(thisWordArr.length ==0 ){
        wordsArr.push(avaNullURL)
      } else  if(thisWordArr.length ==1 ){
        wordsArr.push(`${process.env.PUBLIC_URL}/avatars/${thisWordArr[0]}`);
      } else {
        index = Math.floor( Math.random() * thisWordArr.length )
        wordsArr.push(`${process.env.PUBLIC_URL}/avatars/${thisWordArr[index]}`);
      }
    }
    setAvaURLArr(wordsArr);

    // init
    setCardSide ((wordsArr[1] == avaNullURL)?1:0);
    //console.log('avaURLArr[1], cardSide:',avaURLArr[1], cardSide);
    //alert(wordsArr.toString());
    //return wordsArr;
  }

  /* get tp: "x" for err, [] for ok
  dataArr[0] for report file name & ogg name
  */
  async function getTask() {
    const url = process.env.REACT_APP_BASEURL + `/usertasks/${location}`;

    const res = await axios.get(url, { headers: { 'x-access-token': user['x-access-token'] } });
    //console.log('res.data type, len:', Object.prototype.toString.call(res.data), res.data.length);
    //res.data = ['demot-244-ES-2022-R-5212-FS-demot', {"word": "make","defs": "str","syn": "str", "opp": "str", "hyper": "str"}];
    //console.log('res.data: ', res.data)

    if (Object.prototype.toString.call(res.data) == '[object Array]') {
      //res.data = [res.data[0], {word:"cat", defs: 'a popular pet who is part of the cat family', syn: 'domestic cats,wild cats, big cats', hyper: 'domestic animal'}, {word:"dog", defs: 'a popular pet who is a descendant of the gray wolf.', syn: 'hound, pet', hyper: 'domestic animal'}];
      res.data = res.data.filter(function (e) { return e });  // 2nd remove all empty arr el
      //alert(res.data.length)

      //setDataArr(...res.data);
      dataArr.current = res.data
      wordArr = getCardWordArr(res.data);
      //alert(wordArr.toString())

      await getAvaURLArr2(wordArr);
      //console.log('dataArr, wordArr: ', dataArr, wordArr)
    } else {  // nok ""
      //alert("len = 0")
      //setDataArr([]);  // make len 0
      dataArr.current = []
    }
  }

  async function postResultArr(data) {
    const url = process.env.REACT_APP_BASEURL + `/userspelling`;
    await axios.post(url, { sbArr: data}, { headers: { 'x-access-token': user['x-access-token'] } })
    /*
      .then(res => {
        console.log('test result sent to server succeeded');
      })
      .catch(err => {
        setStatusMsg(axiosEH(err));
      })
    */
    setTimeout(() => {
      window.location.href = "/task";
    }, 4000);
  }

  function currentCardSide() {
    if (avaURLArr[wordIndex.current] == avaNullURL) {
      setCardSide (1);
    } else {
      setCardSide (0);
    }
  }

  function handleKeyUp(e) {
    if (e.key != 'Enter') return;
    if (wordIndex.current >= dataArr.current.length) {  // should not occur
      setStatusMsg(`score ${score.current} of ${wordIndex.current}, ` + taskDoneMsg);
      return;
    }

    //console.log('wordIndex.current, dataArr.current.length: ', wordIndex.current, dataArr.current.length);
    const testWord = dataArr.current[ wordIndex.current].word
    const spelledWord =  e.target.value.trim()
    if (spelledWord.toLowerCase() == testWord.toLowerCase()) {
      score.current = score.current +1;
      resultArr.current.push([wordIndex.current, testWord, spelledWord, 'v', score.current]);
    } else {
      resultArr.current.push([wordIndex.current, testWord, spelledWord, 'x', score.current]);
    }

    setStatusMsg(`score ${score.current} of ${wordIndex.current}`);
    wordIndex.current += 1; currentCardSide();
    document.getElementById("inputID").value="";

    // final chk
    if (wordIndex.current >= dataArr.current.length) {
      //showResultArr(resultArr.current);
      setStatusMsg(`score ${score.current} of ${wordIndex.current -1}, ` + taskDoneMsg);
      score.current = parseInt(100 * score.current / (dataArr.current.length - 1));
      userLevel = setCurrentLevel(user.username, score.current);
      showResultArr(resultArr.current);
      resultArr.current.push(dataArr.current[0] + '-' + score.current); // filename
      postResultArr(resultArr.current);
    }
  }

  function handleSkip() {
    const testWord = dataArr.current[ wordIndex.current].word
    resultArr.current.push([wordIndex.current, testWord, '', 'skipped', score.current]);

    setStatusMsg(`score ${score.current} of ${wordIndex.current}`);
    wordIndex.current += 1;
    // final chk
    if (wordIndex.current < dataArr.current.length) {
      currentCardSide();
    } else {
      //console.log("resultArr.current: ", resultArr.current)
      setStatusMsg(`score ${score.current} of ${wordIndex.current -1}, ` + taskDoneMsg);
      score.current = parseInt(100 * score.current / (dataArr.current.length - 1));
      userLevel = setCurrentLevel(user.username, score.current);
      showResultArr(resultArr.current);
      resultArr.current.push(dataArr.current[0] + '-' + score.current); // filename
      postResultArr(resultArr.current);
    }
  }

  function handleMore() {
    if (avaURLArr[wordIndex.current] == avaNullURL) {
      setCardSide (1);
    } else {
      setCardSide (1-cardSide);
    }
    //console.log('wordIndex.current, cardSide:', wordIndex.current, cardSide);
  }

  function handleMastered() {
    const testWord = dataArr.current[ wordIndex.current].word
    score.current = score.current +1;
    resultArr.current.push([wordIndex.current, testWord, testWord, 'mastered', score.current]);

    setStatusMsg(`score ${score.current} of ${wordIndex.current}`);
    wordIndex.current += 1;
    // final chk
    if (wordIndex.current < dataArr.current.length) {
      currentCardSide();
    } else {
      //console.log("resultArr.current: ", resultArr.current)
      setStatusMsg(`score ${score.current} of ${wordIndex.current -1}, ` + taskDoneMsg);
      score.current = parseInt(100 * score.current / (dataArr.current.length - 1));
      userLevel = setCurrentLevel(user.username, score.current);
      showResultArr(resultArr.current);
      resultArr.current.push(dataArr.current[0] + '-' + score.current); // filename
      postResultArr(resultArr.current);
    }
  }

  useEffect(() => {
    getTask();   // await not work here
  }, []);   // []: render once only


  return (
    <div className="container">
      <div className="music-Container">
        <p style={{ color: 'blue' }}>FiveStar Flashcard Player</p>
        <p style={{ color: '#888888' }}>(3 auto levels)</p>
        {/* <img id='wAvatar' src={avatarURL} alt="word avatar" style={{width:'80%',height:'80%'}} /> */}
        {cardSide == '0' && <img id='wAvatar' src={avaURLArr[wordIndex.current]} alt="word avatar" /> }
        {cardSide == '1' && <textarea readOnly className="textarea is-normal" rows={9}
          value={ textInfoArr[wordIndex.current]}>
        </textarea> }
        {avaURLArr.length <= 1 && <label style={{ color: msgColor }}>Total words: {avaURLArr.length - 1}</label> }
        {avaURLArr.length > 1 && <div>
          <label style={{ color: msgColor }}>Total words: {avaURLArr.length - 1}</label>
          <input id="inputID" className="input is-danger" type="text" name="className" 
            placeholder="Type the word then return"
            onKeyUp={handleKeyUp}>
          </input>
          <span>
            <button className="startButton" onClick={() => { handleMastered() }} >Mastered</button>
          </span> <span> </span>          
          <span>
            <button className="startButton" onClick={() => { handleMore() }} >Side ...</button>
          </span> <span> </span>
          <span>
            <button className="startButton" onClick={() => { handleSkip(true, false) }} >Skip</button>
          </span>  <span></span>
          </div> }
        <label style={{ color: msgColor }}>{statusMsg}</label>
      </div>
      <div className="changeBackgroundBtn" onClick={changeBackground}>
        Change Background
      </div>
    </div>
  );
}